import { render, staticRenderFns } from "./PageRewards.vue?vue&type=template&id=2fae8e3c&scoped=true&"
import script from "./PageRewards.vue?vue&type=script&lang=ts&"
export * from "./PageRewards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae8e3c",
  null
  
)

export default component.exports